import { formatDateTimeToLocaleString } from "@simplyk/common";

import { useLocaleContext } from "@/contexts/LocaleContext";
import { FormChip } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";
import { Bird } from "@/icons/outlined";

export type ThemedEarlyBirdChipProps = {
  closeDate: string;
};

export const ThemedEarlyBirdChip = ({ closeDate }: ThemedEarlyBirdChipProps) => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();

  const formattedEarlyBirdCloseDate = formatDateTimeToLocaleString(closeDate, locale, {
    day: "numeric",
    month: "short",
  });

  return (
    <FormChip
      label={t("dashboard", "ticketing.rate.earlyBirdChip", {
        closingDate: formattedEarlyBirdCloseDate,
      })}
      variant="outlined"
      icon={<Bird />}
      vibe="neutral"
    />
  );
};
